import React from 'react';
import {useSelector} from "react-redux";
import CurrencyUtils from "../../utils/currencyUtils";
import {useTheme} from "styled-components";

const Price = ({classes, largePreText, textBottom, preText, hideCurrency, price, largePostText, postText}) => {
    const selectedCurrency = useSelector(state => state.currency.selectedCurrency || "£");
    const theme = useTheme();
    const excursionCurrency = selectedCurrency === "$" && theme.convertUsdExcursionToGbp ? "£" : selectedCurrency;

    return (
        <div className={"text-primary-dark" + (classes ? " " + classes : "")}>
            <span className={(largePreText ? "text-lg" : "text-base") + (textBottom ? " align-bottom" : "")}>
                {preText}
            </span>
            { excursionCurrency === "€" && <PriceTextComponent textBottom={textBottom} price={price}/> }
            <CurrencyTextComponent
                hideCurrency={hideCurrency}
                textBottom={textBottom}
                currency={excursionCurrency}
            />
            { excursionCurrency !== "€" && <PriceTextComponent textBottom={textBottom} price={price}/> }
            <span className={(largePostText ? "text-lg" : "text-base") + (textBottom ? " align-bottom" : "")}>
                {postText}
            </span>
        </div>
    )
}

export default Price;

const PriceTextComponent = ({textBottom, price}) => <span className={"text-3xl md:text-4xl font-bold" + (textBottom ? " align-bottom" : "")}>
        {isNaN(price) ? price : CurrencyUtils.convertToCurrency(price)}
</span>

const CurrencyTextComponent = ({hideCurrency, textBottom, currency}) => <>
    { !hideCurrency &&
        <span className={"text-xl font-bold" + (textBottom ? " align-bottom" : "")}>
                {currency}
        </span>
    }
</>